export var EventType;
(function (EventType) {
    EventType["TaskIngest"] = "taskIngest";
    EventType["TaskRepetition"] = "taskRepetition";
    EventType["TaskReschedule"] = "taskReschedule";
    EventType["TaskResetComponent"] = "taskResetComponent";
    EventType["TaskUpdateDeleted"] = "taskUpdatedDeleted";
    EventType["TaskUpdateSpecEvent"] = "taskUpdateSpec";
    EventType["TaskUpdateProvenanceEvent"] = "taskUpdateProvenanceEvent";
    EventType["TaskUpdateMetadataEvent"] = "taskUpdateMetadata";
    EventType["AttachmentIngest"] = "attachmentIngest";
})(EventType || (EventType = {}));
export var TaskRepetitionOutcome;
(function (TaskRepetitionOutcome) {
    TaskRepetitionOutcome["Remembered"] = "remembered";
    TaskRepetitionOutcome["Forgotten"] = "forgotten";
    TaskRepetitionOutcome["Skipped"] = "skipped";
})(TaskRepetitionOutcome || (TaskRepetitionOutcome = {}));
//# sourceMappingURL=event.js.map